<template>
  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
  <!-- <div> -->
  <div v-loading="showFlag">
    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
    <t-card>
      <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
      <div
        v-if="isSendFlg"
        :style="{ height: basicHeight + 'px', 'padding-top': '10px' }"
      >
        <t-form
          :model="searchConditionForm"
          label-position="right"
          :label-width="$t('widgetSize.SEND.LABEL_WIDTH_100')"
        >
          <t-row type="flex" justify="left">
            <!-- 得意先納期 -->
            <t-col :span="20" class="left">
              <t-form-item
                :label="$t('resource.SEND.CUS_DELIVERY_DATE')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                  style="
                    margin-top: 3px;
                    min-width: 20px;
                    width: 100%;
                    margin-left: -3px;
                  "
                  class="date_icon_center"
                  :clearable="receRemainFlg"
                />
              </t-form-item>
            </t-col>
          </t-row>
          <t-row class="marginBottom">
            <!-- 一式機能の追加 -->
            <t-col :span="8" class="left">
              <template>
                <t-checkbox
                  v-model="aobASetOnly"
                  :label="$t('resource.SEND.A_SET_ONLY')"
                  style="line-height: 3; margin-left: 20px"
                />
              </template>
            </t-col>

            <t-col :span="8" class="left">
              <template>
                <!-- 入荷残有 -->
                <t-checkbox
                  v-model="receRemainFlg"
                  :label="$t('resource.SEND.REC_REMAIN_FLG')"
                  style="line-height: 3"
                />
              </template>
            </t-col>
            <t-col :span="8" class="center">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>
      <div>
        <t-table
          ref="customerReferenceTable"
          :data="customerReferenceTable"
          header-cell-class-name="bg-default"
          highlight-current-row
          @row-click="SelectRow"
          @row-dblclick="SelectRowAndConfirm"
          :row-class-name="TableRowClassName"
          :height="detailHeight"
          border
        >
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :align="column.align"
          >
          </t-table-column
        ></t-table>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row type="flex" justify="end">
          <div>
            <t-col :span="24">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="ConfirmClick"
                >{{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
//import { DeleteOrderInfo, SearchOrderInfo } from "@/services/numberInfo";
//import { DateFormat } from "@/utils/filter";

import { t } from "@/locales";
import { GetCusMstInfo, GetCusMstInfoSend } from "@/services/customerInfo";
import {
  formatDateToString,
  getAbleCusMstInfoList,
  getDialogContentHeightComm
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, STR_EMPTY } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //明細情報のheight
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      // detailHeight: getDialogContentHeight(
      detailHeight: getDialogContentHeightComm(
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        window.innerHeight,
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 0,
        this.sendFlg ? DIALOG_LINE_HEIGHT * 2 : 0,
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        DIALOG_LINE_HEIGHT * 1,
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        this.sendFlg ? 15 : 0
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      customerReferenceTable: [],
      columns: [
        {
          prop: "cusCode",
          label: "得意先コード",
          width: "120",
          align: "left",
        },
        {
          prop: "cusName",
          label: "得意先名称",
          align: "left",
          minWidth: "200",
        },
        {
          prop: "cusAbbreviation",
          label: "得意先略称",
          width: "150",
          align: "left",
        },
      ],

      data: null,
      currentCuscode: "",

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      isSendFlg: this.sendFlg, // 納品の場合、true；その他の場合、false

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 請求製品選択の得意先選択画面の初期データの変更
      isRequestFlg: this.requestFlg,
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      receRemainFlg: false, // 入荷残有

      //検索条件
      dateRange: [],
      searchConditionForm: {
        searchStartDate: "", // 得意先納期(開始日)
        searchEndDate: "", // 得意先納期(終了日)
        receRemainExist: "", //入荷残有
        aobASetOnly: "", //一式のみ
        //******************納品製品選択画面用*****************
        searchQuoteNo: "", // 見積No./注番
        searchWord: "", //図番、品名、得意先担当者
      },

      // 一式機能の追加
      aobASetOnly: false,

      //基本情報のheight
      basicHeight: this.sendFlg ? DIALOG_LINE_HEIGHT * 2 : 0,

      showFlag: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    //得意先コード
    cusCode: {
      Type: String,
      default: "",
    },

    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 納品の場合、検索の追加
    sendFlg: {
      Type: Object,
      default: false,
    },

    searchCusForm: {
      Type: Object,
      default: null,
    },
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    // 請求製品選択の得意先選択画面の初期データの変更
    requestFlg: {
      Type: Object,
      default: false,
    },

    // 請求製品選択用の得意先リスト
    filterCustomerList: {
      Type: Object,
      default: null,
    },
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

  },

  mounted() {
    this.Init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
  watch: {
    sendFlg(newVal) {
      this.handleResize();
    },
  },
  // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      // this.detailHeight = getDialogContentHeight(
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // this.detailHeight = getDialogContentHeightComm(
      //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      //   window.innerHeight,
      //   0,
      //   DIALOG_LINE_HEIGHT * 1,
      //   0
      // );

      this.basicHeight = this.isSendFlg ? DIALOG_LINE_HEIGHT * 2 : 0;

      var otherSize = this.isSendFlg ? 15 : 0;

      this.detailHeight = getDialogContentHeightComm(
        window.innerHeight,
        this.basicHeight,
        DIALOG_LINE_HEIGHT * 1,
        otherSize
      );
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    },

    //初期化
    Init() {
      if (this.isSendFlg) {
        // 検索条件初期化
        this.searchInfoInit();

        this.searchClick();
      } else {
        //現在選択されている行データの得意先コード
        this.currentCuscode = this.cusCode;
        GetCusMstInfo()
          .then((res) => {
            this.customerReferenceTable = res;

            // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
            // 請求製品選択の得意先選択画面の初期データの変更
            if (this.isRequestFlg && this.filterCustomerList != null) {
              var filterSet = new Set(this.filterCustomerList);
               this.customerReferenceTable = this.customerReferenceTable.filter(item => filterSet.has(item.cusCode));
            }
            // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
            this.getAbleList();
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(
                t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
              );
            }
          });
      }
    },

    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 検索条件初期化
    searchInfoInit() {
      if (!!this.searchCusForm && this.searchCusForm != STR_EMPTY) {
        this.searchConditionForm = [];
        this.searchConditionForm = this.searchCusForm;

        if (this.searchConditionForm.searchStartDate == STR_EMPTY) {
          this.dateRange = [];
        } else {
          this.dateRange = [
            this.searchConditionForm.searchStartDate,
            this.searchConditionForm.searchEndDate,
          ];
        }
        // 入荷残有
        this.receRemainFlg = this.searchConditionForm.receRemainExist;
        this.aobASetOnly = this.searchConditionForm.aobASetOnly; //一式のみ
      } else {
        this.dateRange = [];
        // 入荷残有
        this.receRemainFlg = true;
      }
    },

    // 検索チェック
    searchFormCheck() {
      // 「入荷残有」が「チェックしない」場合、「得意先納期は空であってはならない
      if (!this.receRemainFlg && this.dateRange.length == 0) {
        return false;
      }
      return true;
    },

    //検索条件の調整
    updateSearchForm() {
      //日付の設定
      if (this.dateRange.length > 0) {
        this.searchConditionForm.searchStartDate = formatDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }

      this.searchConditionForm.receRemainExist = this.receRemainFlg;

      this.searchConditionForm.aobASetOnly = this.aobASetOnly; //一式のみ
    },

    // 検索
    searchClick() {
      if (!this.searchFormCheck()) {
        Modal.showWarning("", t("message.SEND.CUS_DELIVERY_DATE_INPUT_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      if (!this.showFlag) {
        this.showFlag = true;
      }

      // 検索条件の処理
      this.updateSearchForm();

      GetCusMstInfoSend(this.searchConditionForm)
        .then((res) => {
          this.customerReferenceTable = res;
          this.getAbleList();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

    // 使用可能な得意先リストの取得
    getAbleList() {
      // 得意先リスト
      this.customerReferenceTable = getAbleCusMstInfoList(
        this.customerReferenceTable,
        this.cusCode
      );
    },

    //确定ボタン
    ConfirmClick() {
      if (!!this.data) {
        //[得意先コード:得意先略称]
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // var result = this.data.cusCode + ":" + this.data.cusAbbreviation;

        if (this.isSendFlg) {
          var result = {
            cusInfo: this.data.cusCode + ":" + this.data.cusAbbreviation,
            searchConditionForm: this.searchConditionForm,
          };
        } else {
          var result = this.data.cusCode + ":" + this.data.cusAbbreviation;
        }
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

        this.$emit("ok", result);
      } else {
        this.$emit("ok", "");
      }
    },

    //行データのダブルクリック処理
    SelectRowAndConfirm(row, column, event) {
      this.currentCuscode = row.cusCode;

      this.TableRowClassName({ row });

      this.ConfirmClick();
    },

    //行データをクリックする
    SelectRow(row, column, event) {
      //this.data = row;

      this.currentCuscode = row.cusCode;

      this.TableRowClassName({ row });
    },

    //「得意先」が選択されている場合は、その行をハイライトする
    TableRowClassName({ row, rowIndex, column }) {
      if (row.cusCode == this.currentCuscode) {
        this.data = row;
        return "current-row";
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
</style>
